var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "hidden relative lg:flex items-center bg-indigo-200 overflow-visible rounded-sm h-48 w-full"
  }, [_c('div', {
    staticClass: "px-12 cursor-default xl:pr-72"
  }, [_c('p', {
    staticClass: "text-4xl text-gray-900"
  }, [_vm._v("\n        " + _vm._s(_vm.infosPass.name) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "inline-flex flex-col xxl:flex-row"
  }, [_c('div', {
    staticClass: "text-indigo-600 inline-flex font-light"
  }, [_c('icon', {
    attrs: {
      "name": "layers"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Neopass'
      }
    }
  }, [_vm._v("\n             " + _vm._s(_vm.role === _vm.constants.ROLE_BENEFICIAIRE || _vm.$freeParticulier() ? 'Mon carnet' : 'Mes carnets') + "\n            de parcours \n          ")]), _vm._v(" "), _c('span', {
    staticClass: "hidden xxl:inline-block"
  }, [_vm._v("> ")])], 1), _vm._v(" "), _c('span', {
    staticClass: "text-pink-600 font-light"
  }, [_c('router-link', {
    attrs: {
      "to": '/form/neopass/' + _vm.infosPass.id_pass
    }
  }, [_vm._v(_vm._s(_vm.infosPass.name))]), _vm._v(" "), _c('span', {
    staticClass: "hidden xxl:inline-block"
  }, [_vm._v("> ")])], 1), _vm._v(" "), _c('span', {
    staticClass: "text-gray-600 font-light"
  }, [_vm._v("Cartographie individuelle")])])]), _vm._v(" "), _c('illustration', {
    staticClass: "hidden xl:block absolute right-5 xl:right-10 w-60 xl:w-72",
    attrs: {
      "name": "cartographie"
    }
  })], 1), _vm._v(" "), _vm.allowed ? _c('div', [_c('div', {
    staticClass: "flex mt-16 mb-16 items-center"
  }, [_vm.$can('cartography_individual_export') ? _c('action-button', {
    staticClass: "mr-10",
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-gray-900",
      "bg-color": "bg-indigo-300",
      "bg-color-square": "bg-indigo-200",
      "icon-color": "text-indigo-600",
      "libelle": "Imprimer",
      "icon": "printer"
    }
  }) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/cartographies/collectives/informations'
      }
    }
  }, [_vm.$can(_vm.constants.PERMISSION_CARTOGRAPHIE_COLLECTIVE_DISPLAY) ? _c('action-button', {
    staticClass: "mr-10",
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-gray-900",
      "bg-color": "bg-pink-300",
      "bg-color-square": "bg-pink-100",
      "icon-color": "text-pink-600",
      "libelle": "Cartographie collective",
      "icon": "bar-chart-2",
      "enable-action": false
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col"
  }, [_c('div', {
    staticClass: "relative align-middle min-w-full shadow sm:rounded-lg border-b border-gray-200 bg-white pb-10 table min-h-halfscreen"
  }, [_c('router-view')], 1)])]) : _c('page-not-allowed')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }